import { ArticleCategoryDialog } from "@/v2/features/article-category";

interface ZendeskKnowledgeIntegrationProps {
  onClose: () => void;
  onSave: () => void;
}

export function ZendeskKnowledgeIntegration({
  onClose,
  onSave,
}: ZendeskKnowledgeIntegrationProps) {
  return (
    <ArticleCategoryDialog
      source="zendesk"
      title="Configure Zendesk Article Categories"
      description="Select which article categories to include in your knowledge base integration."
      onClose={onClose}
      onSave={onSave}
      loadingSubtext="Please wait while we fetch your Zendesk configuration"
    />
  );
}
